import React from 'react';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './ExemptTax.st.css';

type PartialTaxProps = {
  originalAmount: string;
  amount: string;
};

export enum ExemptTaxDataHooks {
  OriginalAmount = 'originalAmount',
  FinalAmount = 'finalAmount',
}

export const ExemptTax = ({originalAmount, amount}: PartialTaxProps) => (
  <div className={classes.taxPriceContainer}>
    <Text priority={TextPriority.secondary} data-hook={ExemptTaxDataHooks.OriginalAmount}>
      <del>{originalAmount}</del>
    </Text>
    <Text data-hook={ExemptTaxDataHooks.FinalAmount}>{amount}</Text>
  </div>
);
